export default function determineHideAllEditButtons(array = []) {
  let allHidden = true;
  array.forEach((gift) => {
    if (gift.userCanEdit) allHidden = false;
  });
  return allHidden;
}
